import React from 'react';
import styled from 'styled-components';
import { Icon } from '@blueprintjs/core';

export const ListHeader = ({ icon, color, title, type }) => (
  <DrawerHeader>
    <div>
      <Icon icon={icon} color={color} iconSize={Icon.SIZE_LARGE} />
      {title}
    </div>
    {type === 'upcoming' && <span>Next Two Months</span>}
  </DrawerHeader>
);

const DrawerHeader = styled.div`
  border-radius: 3px 3px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 700;
  background-color: #fff;

  svg {
    margin-right: 1rem;
  }
`;
